import React from "react";
import "./AskAgainButton.css";
import { strings } from "../../translations/strings";

const AskAgainButton = ({ onPress }) => {
  return (
    <div className="ask-again-button-container">
      <div className="ask-again-button" onClick={onPress}>
        <span className="ask-again-button-text">{strings.ask_again}</span>
      </div>
    </div>
  );
};
export default AskAgainButton;
